import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const postman = defineConnector({
  identifier: "postman",
  name: "Postman",
  tagLine: "API development and testing",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.getpostman\\.com/.*",
  auth: (app) => headerAuth([{ name: "X-Api-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Sign in to [Postman](https://go.postman.co/) and navigate to your account settings to generate an API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "Postman API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.getpostman.com/me",
  },
});
